import { Transforms, Editor, Node, Path, Text } from 'slate'
import { Registry } from '@react-registry'
import { JsonNode, JsonEditor } from '../../../../SuperChargedRte/utils/types'
import { removeDoubleParagraphs } from './utils'

export const withPara = (editor: JsonEditor) => {
  const { insertBreak, normalizeNode } = editor

  editor.insertBreak = () => {
    const { selection } = editor
    if (selection) {

      const [isParaOrFrag] = Editor.nodes(editor, {
        match: (n: JsonNode) => {
          return n.type === 'p' || n.type === 'fragment'
        }
      })

      const csBreakLineOnEnter = editor.csBreakLineOnEnter;

      if (isParaOrFrag && editor.csOnlyBreakline && csBreakLineOnEnter) {
        editor.insertText('\n')
      }
      else if (isParaOrFrag && editor.csOnlyBreakline) {
        const [currNode] = Node.last(editor, selection.anchor.path)
        const nextNode = Editor.next(editor, { at: selection.anchor.path })

        if (!Text.isText(currNode)) return

        const textLength = currNode.text.length

        if (currNode.text[textLength - 1] === '\n' && !currNode.hasOwnProperty('break') && !nextNode) {
          Editor.deleteBackward(editor)
          Transforms.insertNodes(editor, { type: 'p', children: [{ text: '' }] } as Node, { at: editor.selection, select: true })
        }
        else {
          let nextPath = Editor.next(editor, { at: editor.selection })?.[1]
          if (nextPath && nextPath[nextPath.length - 2] === selection.anchor.path[selection.anchor.path.length - 2]) {
            if (currNode.text === "\n") {
              nextPath[nextPath.length - 1] = nextPath[nextPath.length - 1] + 1
            }
            editor.insertText('\n')
            if (currNode.text[textLength - 1] !== '\n' && currNode.text.indexOf("\n") > -1) {
              return
            }
            if (currNode.text[textLength - 1] === '\n') {
              Transforms.select(editor, {
                "anchor": {
                  "path": nextPath,
                  "offset": currNode.text.lastIndexOf("\n") + 1
                },
                "focus": {
                  "path": nextPath,
                  "offset": currNode.text.lastIndexOf("\n") + 1
                }
              })
            }

            else {
              let newSelection = {
                "anchor": {
                  "path": nextPath,
                  "offset": 0
                },
                "focus": {
                  "path": nextPath,
                  "offset": 0
                }
              }
              Transforms.select(editor, newSelection)
            }
          }
          else {
            editor.insertText('\n')
          }
        }
      }
      else {
        insertBreak()
        try {
          const [pNodeEntry] = Editor.nodes(editor, {
            match: (n: JsonNode) => {
              return n.type === 'p'
            },
            mode: "lowest"
          })

          if (pNodeEntry && Array.isArray(pNodeEntry) && pNodeEntry.length > 1 && pNodeEntry[1]) {
            const path = pNodeEntry[1]
            Transforms.setNodes<JsonNode>(editor, { attrs: {} }, { at: path })
          }
        }
        catch (e) {
          console.error(e)
        }
      }
    }
  }

  editor.normalizeNode = (entry: [JsonNode, Path]) => {
    const [node, path] = entry
    if (node.type !== 'p') return normalizeNode(entry)
    removeDoubleParagraphs(editor, entry)
    normalizeNode(entry)
  }
  return editor
}

Registry.register(withPara, { id: 'withPara', registry: 'v2.plugin' })